export const incomeStatementFieldName = {
    basicProfitLossAndEstimates: "งบกำไร (ขาดทุน) เบื้องต้นและประมาณการ",
    group: "หมวด",
    revenue: "ยอดขาย",
    expense: "ค่าใช้จ่าย",
    glossProfit: "กำไร (ขาดทุน) จากการดำเนินงาน",
    ebitda: "กำไร (ขาดทุน) ก่อนหักดอกเบี้ย ภาษี ค่าเสื่อมและตัดจำหน่าย (EBITDA)",
    netProfit: "กำไร (ขาดทุน) สุทธิ",
    list:"รายการ"
  };
  
  export const balanceSheetFieldName= {
    preliminaryBalanceSheetProjections: "งบดุลเบื้องต้นและประมาณการ",
    asset: "1.สินทรัพย์",
    currentAsset: "1.1 สินทรัพย์หมุนเวียน",
    fixedAsset: "1.2 สินทรัพย์ถาวร",
    liabilityEquity: "2.หนี้สินและส่วนของทุน",
    liability: "2.1 หนี้สิน",
    currentLiability: "2.1.1 หนี้สินหมุนเวียน",
    longTermLiability: "2.1.2 หนี้สินระยะยาว",
    equity: "2.2 ส่วนของทุน",
    group: "หมวด",
    list:"รายการ"
  };
  export const cashFlowFieldName= {
    preliminaryCashFlowStatementsEstimates: "งบกระแสเงินสดเบื้องต้นและประมาณการ",
    operation: "1.กระแสเงินสดจากดำเนินงาน",
    investing: "2.กระแสเงินสดจากกาารลงทุน",
    financing: "3.กระแสเงินสดจากการจัดหาเงิน",
    cashFlow: "4.กระแสเงินสด",
    netCashFlow: "4.1 เงินสดสุทธิรับมาก (น้อย) กว่าเงินสดจ่าย",
    cashBalanceBeginning: "4.2 เงินสดคงเหลือต้นงวด",
    cashBalanceEnding: "4.3 เงินสดคงเหลือปลายงวด",
    list:"รายการ"
  };
  export const  orgLocalDebtEstimationFieldName= {
    list:"รายการ",
    estimateAllDebt: "ประมาณการภาระหนี้ทั้งหมด",
    "domesticLoanSources": "แหล่งเงินกู้ในประเทศ",
    "foreignLoanSources": "แหล่งเงินกู้ต่างประเทศ",
    outstandingDebt: "1. ยอดหนี้คงค้าง",
    disbursement: "2. การเบิกจ่าย",
    repayment: "3. การชำระคืน",
    principle: "3.1 เงินต้น",
    interest: "3.2 ดอกเบี้ยและค่าธรรมเนียม",
    netCashFlow: "4. กระแสเงินไหลเข้าสุทธิ"
  };
  export const  govLocalDebtEstimationFieldName= {
    list:"รายการ",
    "estimateGovernmentDebt": "ประมาณการภาระหนี้ที่รัฐบาลต้องรับภาระ",
    "domesticLoanSources": "แหล่งเงินกู้ในประเทศ",
    "foreignLoanSources": "แหล่งเงินกู้ต่างประเทศ",
    "principle": "1. เงินต้น",
    "interest": "2. ดอกเบี้ย",
    "fee": "3. ค่าธรรมเนียมและอื่น ๆ"
  };
  export const  financialRatioFieldName= {
    list:"รายการ",
    "financialRatio": "อัตราส่วนทางการเงิน",
    "debtServiceCoverageRato": "1.Debt Service Coverage Rato : (EBITDA + ภาระเงินต้นและดอกเบี้ยที่รัฐบาลรับภาระ) / ภาระหนี้",
    "profitBeforeInterest": "- กำไรก่อนหักดอกเบี้ยจ่าย ภาษี และค่าเสื่อมราคา (EBITDA)",
    "debtBurden": "- ภาระหนี้ (เงินต้น+ดอกเบี้ยที่ครบกำหนดชำระ)",
    "pDebt": "   - ภาระหนี้ (เงินต้นที่ครบกำหนดชำระ)",
    "pDebtG": "      - ภาระหนี้ (เงินต้นที่ครบกำหนดชำระ: รัฐบาลรับภาระ)",
    "pDebtO": "      - ภาระหนี้ (เงินต้นที่ครบกำหนดชำระ: หน่วยงานรับภาระ)",
    "iDebt": "   - ภาระหนี้ (ดอกเบี้ยครบกำหนดชำระ)",
    "iDebtG": "      - ภาระหนี้ (ดอกเบี้ยที่ครบกำหนดชำระ: รัฐบาลรับภาระ)",
    "iDebtO": "      - ภาระหนี้ (ดอกเบี้ยที่ครบกำหนดชำระ: หน่วยงานรับภาระ)",
    "govDebt": "- ภาระเงินต้นและดอกเบี้ยที่รัฐบาลรับภาระ",
    "pGovDebt": "   - ภาระเงินต้นที่รัฐบาลรับภาระ",
    "iGovDebt": "   - ภาระดอกเบี้ยที่รัฐบาลรับภาระ",
    "debtEquityRatio": "2.อัตราส่วนหนี้สินต่อทุน : (หนี้สินรวม/ส่วนของผู้ถือหุ้น)",
    "totalLiabilities": "- หนี้สินรวม",
    "shareholdersEquity": "- ส่วนของผู้ถือหุ้น",
    "debtTotalAssets": "3.อัตราส่วนหนี้สินต่อสินทรัพย์รวม : (หนี้สินรวม/สินทรัพย์)",
    "totalAssets": "- สินทรัพย์รวม",
    "workingCapitalRatio": "4.อัตราส่วนเงินทุนหมุนเวียน : (ทรัพย์สินหมุนเวียน/หนี้สินหมุนเวียน)",
    "currentAssets": "- ทรัพย์สินหมุนเวียน",
    "totalCurrentLiabilities": "- หนี้สินหมุนเวียน",
    "returnFixedAssets": "5.อัตราผลตอบแทนต่อสินทรัพย์ถาวร : (กำไรสุทธิ/สินทรัพย์ถาวร)",
    "netProfit": "- กำไรสุทธิ",
    "permanentAsset": "- สินทรัพย์ถาวร",
    "returnTotalAssets": "6.อัตราผลตอบแทนต่อสินทรัพย์รวม : (กำไรสุทธิ/สินทรัพย์รวม)",
    "returnSales": "7.อัตราผลตอบแทนต่อยอดขาย : (กำไรสุทธิ/ยอดขาย)",
    "sales": "- ยอดขาย"
  };